import { createAction } from '../../techstyle-shared/redux-core';

export const trackCheckoutCTAClick = createAction('TRACK_CHECKOUT_CTA_CLICK');
export const trackShowOutfitDetailsClick = createAction(
  'TRACK_SHOW_OUTFIT_DETAILS_CLICK'
);
export const trackHideOutfitDetailsClick = createAction(
  'TRACK_HIDE_OUTFIT_DETAILS_CLICK'
);
